import React from 'react';
import PlanSubscription from '../PlanSubscription/PlanSubscription';
import PaymentMethodSubscription from '../PaymentMethodSubscription/PaymentMethodSubscription';
import AddressSubscription from '../AddressSubsription/AddressSubscription';
import InvoiceHistorySubscription from '../InvoiceHistorySubscription/InvoiceHistorySubscription';

const Dashboard = () => {
    return (
        <div className="flex flex-col md:flex-row   md:space-y-0 md:space-x-8">
            <div className="flex-1 space-y-8">
                <PlanSubscription />
                {/* <PaymentMethodSubscription /> */}
                {/* <AddressSubscription /> */}
            </div>
         <InvoiceHistorySubscription/>
        </div>
    );
};

export default Dashboard;
